<template>
  <div v-if="videoRoom" class="w-100">
    <proa-card class="h-100 d-flex flex-column" no-padding>
      <template v-slot:header>
        <div class="d-flex justify-content-between align-items-center">
          <proa-back-button
            @onClick="onClickBackButton"
          />
          <proa-heading detail class="room-name">
            <span>
              <img :src="require('@/assets/images/icons/meeting_room.png')" />
              <span>{{ videoRoomMaster.roomName }}</span>
            </span>
          </proa-heading>
          <div class="d-flex align-items-center">
            <template v-if="$mq!=='sm'" >
              <span class="prefix-max">{{ $t('common.max') }}</span>
              <span>{{ videoRoomMaster.roomCapacity + $t('common.person') }}</span>
            </template>
            <div
              v-if="enabledVideoRoomEditMenu"
              v-click-outside="() => { displayingVideoRoomEditMenu = false }"
              class="video-room-item"
              @click="displayingVideoRoomEditMenu = !displayingVideoRoomEditMenu"
            >
              <img :src="require('@/assets/images/icons/ellipsis.png')" />
              <div
                v-show="displayingVideoRoomEditMenu"
                class="video-room-edit-menu"
              >
                <div
                  @click="$router.push({ name: 'editMeetingReservations', params: { videoRoomMasterId: videoRoomMasterId, id: videoRoomId } })"
                  class="menu"
                >
                  {{ $t('pages.meeting.reservations.show.editVideoRoom') }}
                </div>
                <div
                  @click="deleteVideoRoomModal = true"
                  class="menu"
                >
                  {{ $t('pages.meeting.reservations.show.deleteVideoRoom') }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <div v-if="videoRoom" class="reservation-content">
        <table class="table-attributes">
          <tbody>
            <tr v-if="$mq==='sm'">
              <td class="d-flex justify-content-end">
                <span class="prefix-max">{{ $t('common.max') }}</span>
                <span>{{ videoRoomMaster.roomCapacity + $t('common.person') }}</span>
              </td>
            </tr>
            <tr>
              <th>{{ $t('models.videoRoom.reservationAt') }}</th>
              <!-- TODO: 日付またぎ対応 -->
              <td>
                <span class="mr-2">{{ videoRoom.startAt | moment('YYYY年MM月DD日（ddd）') }}</span>
                <span>{{ videoRoom.startAt | moment('HH:mm') }}〜{{ videoRoom.endAt | moment('HH:mm') }}</span>
              </td>
            </tr>
            <tr>
              <th>{{ $t('models.videoRoom.attributes.meetingTitle') }}</th>
              <td>{{ videoRoom.meetingTitle }}</td>
            </tr>
            <tr>
              <th valign="top">{{ $t('models.videoRoom.attributes.meetingDescription') }}</th>
              <td class="text-pre-wrap" valign="top">{{ videoRoom.meetingDescription }}</td>
            </tr>
            <tr>
              <th>{{ $t('models.videoRoom.attributes.roomPassword') }}</th>
              <td>{{ $t(`models.videoRoom.${ videoRoom.roomLocked ? 'locked': 'unlocked' }`) }}</td>
            </tr>
          </tbody>
        </table>
        <div class="members-container">
          <div class="members">
            <div class="members-innner-scroll-wrapper">
              <span class="title">{{ $t('models.videoRoom.joinedMembers') }}（{{ users.length }}{{ $t('common.person') }}）</span>
              <div v-for="user in users" :key="user.id" class="member">
                <div v-if="videoRoom.temporaryGuestUserIds.includes(user.id)">
                  <proa-avatar
                    :src="require('@/assets/images/avatar_default.png')"
                    size="sm"
                    guest
                  />
                  <span class="ml-2 pl-1">
                    <span>{{ user.lastName }} </span>
                    <span class="text-secondary">{{ user.firstName }}</span>
                    <span v-if="videoRoom.roomOwnerId == signedInUser.id"> / {{ user.email }}</span>
                  </span>
                </div>
                <div v-else>
                  <proa-avatar
                    :src="user.meta.avatar || require('@/assets/images/avatar_default.png')"
                    class="clickable"
                    size="sm"
                    @click.native="setMemberModalId(user.id)"
                  />
                  <span class="ml-2 pl-1">{{ user.meta.displayName }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="members">
            <div class="members-innner-scroll-wrapper">
              <span class="title">{{ $t('models.videoRoom.unjoinedMembers') }}（{{ unjoinedUsers.length }}{{ $t('common.person') }}）</span>
              <div v-for="user in unjoinedUsers" :key="user.id" class="member">
                <div v-if="videoRoom.temporaryGuestUserIds.includes(user.id)">
                  <proa-avatar
                    :src="require('@/assets/images/avatar_default.png')"
                    size="sm"
                    guest
                  />
                  <span class="ml-2 pl-1">
                    <span>{{ user.lastName }} </span>
                    <span class="text-secondary">{{ user.firstName }}</span>
                    <span v-if="videoRoom.roomOwnerId == signedInUser.id"> / {{ user.email }}</span>
                  </span>
                </div>
                <div v-else>
                  <proa-avatar
                    :src="user.meta.avatar || require('@/assets/images/avatar_default.png')"
                    class="clickable"
                    size="sm"
                    @click.native="setMemberModalId(user.id)"
                  />
                  <span class="ml-2 pl-1">{{ user.meta.displayName }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="enabledFooter"
        class="reservation-footer"
      >
        <proa-button
          v-if="videoRoom.inDuration"
          @click.native="onClickEnterMeetingRoom"
          variant="primary"
          class="default-button-width"
        >
          {{ $t('common.enterMeetingRoom') }}
        </proa-button>
        <proa-button
          v-else-if="videoRoom.isWaitable()"
          @click.native="onClickEnterMeetingRoom"
          variant="primary"
          class="default-button-width"
        >
          {{ $t('common.enterWaitingRoom') }}
        </proa-button>
      </div>
    </proa-card>
    <proa-modal
      v-if="videoRoomMaster"
      :modal="deleteVideoRoomModal"
      :title="$t('common.confirm')"
      @close="() => { if (!deleteVideoRoomRequesting) { deleteVideoRoomModal = false } }"
    >
      <proa-heading sub>{{ $t('common.modals.deleteVideoRoomModal.confirmMessage') }}</proa-heading>
      <template v-slot:footer>
        <proa-button
          @click.native="deleteVideoRoomModal = null"
          :disabled="deleteVideoRoomRequesting"
          class="mr-2"
        >
          {{ $t('common.cancel') }}
        </proa-button>
        <proa-button
          @click.native="onConfirmedDeleteVideoRoom"
          :loading="deleteVideoRoomRequesting"
          variant="secondary"
        >
          {{ $t('common.delete') }}
        </proa-button>
      </template>
    </proa-modal>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import ClickOutside from 'vue-click-outside'
import User from '@/store/models/User'
import VideoRoomMaster from '@/store/models/VideoRoomMaster'
import VideoRoom from '@/store/models/VideoRoom'

export default {
  name: 'ShowMeetingReservations',
  directives: {
    ClickOutside
  },
  computed: {
    returnPath: function() { return this.$route.params.returnPath },
    videoRoomMasterId: function() { return this.$route.params.videoRoomMasterId },
    videoRoomMaster: function() { return VideoRoomMaster.find(this.videoRoomMasterId) },
    videoRoomId: function() { return this.$route.params.id },
    videoRoom: function() { return VideoRoom.find(this.videoRoomId) },
    users: function() {
      return User.findIn(this.videoRoom.joinedUserIds).concat(this.videoRoom.guestUsers.filter((guestUser) => {
        return this.videoRoom.joinedUserIds.includes(guestUser.id)
      }))
    },
    unjoinedUsers: function() {
      return User.findIn(this.videoRoom.userIds.filter(userId => !this.videoRoom.joinedUserIds.includes(userId))).concat(this.videoRoom.guestUsers.filter((guestUser) => {
        return !this.videoRoom.joinedUserIds.includes(guestUser.id)
      }))
    },
    enabledFooter: function() {
      return this.videoRoom.userIds.includes(this.signedInUser.id)
             && (this.videoRoom.inDuration || this.videoRoom.isWaitable() || this.videoRoom.roomOwnerId == this.signedInUser.id)
    },
    enabledVideoRoomEditMenu: function() {
      return !this.videoRoom.inDuration && this.videoRoom.roomOwnerId == this.signedInUser.id
    },
    ...mapGetters({
      signedInUser: 'auth/signedInUser'
    })
  },
  data() {
    return {
      displayingVideoRoomEditMenu: false,
      deleteVideoRoomModal: false,
      deleteVideoRoomRequesting: false
    }
  },
  methods: {
    onClickBackButton: function() {
      if (this.returnPath) {
        this.$router.push({ path: `/${this.returnPath}` })
      } else {
        this.$router.push({ name: 'indexMeetingReservations', params: { id: this.videoRoomMasterId } })
      }
    },
    onClickEnterMeetingRoom: function() {
      this.$router.push({ name: 'indexRoom', params: { videoRoomMasterId: this.videoRoomMasterId, id: this.videoRoomId } })
    },
    async onConfirmedDeleteVideoRoom() {
      this.deleteVideoRoomRequesting = true
      await this.apiDeleteVideoRoom({
        videoRoomMasterId: this.videoRoomMasterId,
        id: this.videoRoomId
      })
      this.onClickBackButton()
    },
    ...mapMutations({
      setMemberModalId: 'setMemberModalId'
    }),
    ...mapActions({
      apiGetVideoRoomMaster: 'entities/videoRoomMasters/show',
      apiGetVideoRoom: 'entities/videoRooms/show',
      apiDeleteVideoRoom: 'entities/videoRooms/destroy',
      apiPutUserNotificationToRead: 'entities/userNotifications/updateToRead'
    })
  },
  async created() {
    // NOTE:
    // VideoRoomMasterが未取得であれば取得
    // => 取得できればVideoRoom取得
    // => VideoRoomが取得できなければ会議室一覧画面に強制遷移
    if (!this.videoRoomMaster) await this.apiGetVideoRoomMaster(this.videoRoomMasterId)
    if (this.videoRoomMaster) {
      await this.apiGetVideoRoom({
        videoRoomMasterId: this.videoRoomMasterId,
        id: this.videoRoomId
      })
    }
    if (!this.videoRoom || this.videoRoomMaster.roomType === 'cafeRoom') {
      return
    }
    if (this.videoRoom.userNotificationId) this.apiPutUserNotificationToRead(this.videoRoom.userNotificationId)
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/variables";
@import "@/styles/mediaquery";

.room-name span {
  display: flex;
  align-items: center;

  img {
    width: 26px;
    height: 26px;
    margin-right: 10px;
  }
}

.prefix-max {
  color: $secondary-color;
  font-weight: 600;
  margin-right: 10px;
}

.reservation-content {
  flex-grow: 1;
  height: 100%;
  display: flex;
  flex-direction: column;

  .table-attributes {
    width: 100%;

    tr {
      display: block;
      border-bottom: 1px solid $light-border-color;
      padding: 15px 20px;

      @include mq(md) {
        display: table-row;
        border-bottom: 1px solid $dark-border-color;
        padding: 0;
      }
    }

    th {
      display: block;
      width: 100%;
      padding: 0;
      font-weight: 600;

      @include mq(md) {
        display: table-cell;
        width: 1px;
        white-space: nowrap;
        padding: 20px 50px 20px 20px;
      }
    }

    td {
      display: block;
      width: 100%;
      padding: 0;
      word-break: break-all;

      @include mq(md) {
        display: table-cell;
        width: auto;
        padding: 20px 20px 20px 0;
      }
    }
  }

  .members-container {
    display: flex;
    flex-direction: column;
    flex-grow: 1;

    @include mq(md) {
      flex-direction: row;
    }

    .members {
      position: relative;
      flex-basis: 50%;
      min-height: 200px;

      @include mq(md) {
        min-height: auto;
      }
      &:first-child {
        border-bottom: 1px solid $light-border-color;

        @include mq(md) {
          border-bottom: none;
          border-right: 1px solid $dark-border-color;
        }
      }

      .members-innner-scroll-wrapper {
        position: absolute;
        height: 100%;
        width: 100%;
        padding: 20px;
        overflow-y: auto;
        display: flex;
        flex-direction: column;
      }

      .title {
        font-weight: 600;
        margin-bottom: 20px;
      }

      .member {
        margin-bottom: 10px;

        &:first-child::before {
          content: '';
          display: block;
          height: 20px;
        }

        &:last-child::after {
          content: '';
          display: block;
          height: 20px;
        }
      }
    }
  }
}

.reservation-footer {
  display: flex;
  justify-content: center;
  padding: 20px;
  border-top: 1px solid $dark-border-color;

  @include mq(md) {
    justify-content: flex-end;
  }
}

.video-room-item {
  position: relative;
  cursor: pointer;
  width: 26px;
  height: 26px;
  padding: 3px;
  margin-left: 10px;
  border-radius: 4px;
  display: flex;

  &:hover {
    background-color: $background-color;
  }

  img {
    width: 100%;
    height: 100%;
  }
}

.video-room-edit-menu {
  position: absolute;
  z-index: 1;
  top: 40px;
  right: 0;
  width: 250px;
  background-color: white;
  border-radius: 4px;
  box-shadow: 0px 0px 4px #00000026;

  .menu {
    cursor: pointer;
    padding: 10px;
    font-size: 13px;

    &:hover {
      background-color: $light-gray-color;
    }
  }
}
</style>
